import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { getToday, ONE_WEEK } from "@/utils/date-formatter/getToday";
import { SearchBarType } from "@/components/dynamic-form/constants";
import dayjs from "project-config/utils/dayjs";
import { useAccountOptions } from "@/pages/consumption/hooks/useAccountOptions";
import { usePlatformOptions } from "@/pages/consumption/hooks/usePlatformOptions";
import { useProjectOptions } from "@/pages/consumption/hooks/useProjectOptions";

export function useSearchConfig() {
  const accountOptions = useAccountOptions();
  const submitUserNameOptions = accountOptions.map((item) => ({
    label: item.label,
    value: item.label,
  }));
  const platformOptions = usePlatformOptions();
  const projectOptions = useProjectOptions();

  const searchConfig = getSearchConfig(() => {
    const t = getTranslateNsT("consumption");

    const now = getToday();
    const weekAgo = new Date(now.getTime() - ONE_WEEK);

    return [
      {
        type: SearchBarType.DatePicker,
        field: "time",
        label: t("consumption_time_selector"),
        limitMonthNum: 3,
        isTrendsChangeDate: true,
        props: {
          allowClear: false,
          defaultValue: [dayjs(weekAgo), dayjs(now)],
        },
      },
      {
        type: SearchBarType.Select,
        label: t("user_operate_record_user_name_alias"),
        field: "userId",
        props: {
          allowClear: true,
          options: accountOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Select,
        label: t("user_consume_pick_submit_account"),
        field: "submitUserName",
        props: {
          allowClear: true,
          options: submitUserNameOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Select,
        field: "platform",
        label: t("user_consume_pick_platform"),
        props: {
          allowClear: true,
          options: platformOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Select,
        label: t("user_consume_pick_project"),
        field: "projectId",
        props: {
          showSearch: true,
          filterOption: (input, option) => {
            return (
              (option?.label as string)
                ?.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
          },
          allowClear: true,
          options: projectOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Input,
        field: "company",
        label: t("consumption_table_header_company"),
        props: {
          placeholder: t("consumption_company_placeholer"),
        },
      },
      {
        type: SearchBarType.Input,
        field: "taskIds",
        label: t("user_operate_record_task_id"),
        props: {
          placeholder: t("consume_work_id_placeholder"),
        },
      },
    ];
  });

  return { searchConfig };
}
